
import { Component, Vue, Ref } from 'vue-property-decorator'
import { PersonService } from '@/services'
import FullLoading from '@/components/full_loading/index.vue'
import PersonTable from './components/person_table.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import { peopleTypes } from '@/constants/peopleTypes'

@Component({
    name: 'person-keyword',
    components: {
        PersonTable,
        ScrollTo,
        FullLoading
    }
})
export default class Keyword extends Vue {
    private personList = []
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private query = ''
    private isLoading = false
    private loadingText = ''
    private approvalStatus = 1
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private selectedPersonType: number | null = null
    private peopleTypes = peopleTypes

    private async mounted() {
        this.getPersonList()
    }

    private showLoading() {
        this.isLoading = true
    }

    private hideLoading() {
        this.isLoading = false
    }

    /** 获取企业列表 */
    private async getPersonList() {
        this.showLoading()
        const params = {
            query: this.query,
            check: this.approvalStatus,
            page_index: this.pageIndex,
            page_size: this.pageSize,
            person_type: this.selectedPersonType !== null ? this.selectedPersonType : undefined
        }

        const result = await PersonService.getPersonList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.personList = result.data.list
        }
        this.hideLoading()
    }

    private reset() {
        this.pageIndex = 1
        this.pageTotal = 0
    }

    private onSearch() {
        this.reset()
        this.getPersonList()
    }

    private onResetInput() {
        if (!this.query) return
        this.query = ''
        this.selectedPersonType = null
        this.getPersonList()
    }

    private onApprovalStatusChange(status: number) {
        this.approvalStatus = status
        this.getPersonList()
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getPersonList)
    }
    private onPersonTypeChange(value: number | null) {
        this.selectedPersonType = value
        this.reset()
        this.getPersonList()
    }
}
